import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, radius, spacing, breakpoints } = globalStyles;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 340px;
  box-sizing: border-box;
  padding: ${spacing.space24};
  background-color: ${colors.primary.offWhite};
  border-radius: ${radius.medium};
  border: 1px solid rgba(82, 97, 90, 0.2);
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.12);

  @media (max-width: ${breakpoints.m}) {
    min-height: 390px;
    padding: ${spacing.space24};
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.space12};
  margin-bottom: ${spacing.space16};
`;

export const GoogleLogo = styled.img`
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
`;

export const CustomerName = styled.p`
  color: ${colors.primary.green};
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 ${spacing.space12};
`;

export const Testimonial = styled.p`
  color: ${colors.primary.darkGreen};
  line-height: 1.6;
  margin: 0;
`;

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  color: ${colors.primary.darkGreen};
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  margin-top: auto;
  padding-top: ${spacing.space16};
  text-align: left;
  font-size: 0.9rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;
